export default __webpack_public_path__ + "static/media/lunch2.97f8ede1.png";